var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"transform":"scale(0.8)"},attrs:{"id":"login_container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }